import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { takeUntil } from 'rxjs/operators';

import { Selectors } from 'store/root-reducer';
import { BillableItem } from 'modules/shared/models/billable.models';

import { SearchesCommon } from '../searches.common';
import { InternetSearchDetailComponent } from '../components/searches-detail/internet-search-detail/internet-search-detail.component';

@Component({
  selector: 'artemis-searches-internet',
  templateUrl: './searches-internet.component.html',
  styleUrls: ['./searches-internet.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class SearchesInternetComponent extends SearchesCommon implements OnInit {

  displayedColumns: Array<string> = [];
  currentPage: number;
  isFilterOn: boolean = false;

  isNlpEnabled: boolean = false;

  originalData: Array<any>;

  ngOnInit() {
    this.getBillableInfo();
  }

  /**
   * Get subscription information from state to decide whether NLP is enabled
   * @method getBillableInfo
   */
  private getBillableInfo(): void {
    this.store.select(Selectors.billable.getNLP)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((nlpEnabled: BillableItem) => {
        this.isNlpEnabled = nlpEnabled ? nlpEnabled.display : false;
        this.setTableColumns();
      });
  }

  /**
   * Set different table columns based on whether NLP is enabled
   * @method setTableColumns
   */
  private setTableColumns(): void {
    if (this.isNlpEnabled) {
      // Set the column name as nlpJson.sentiment.score to enable sorting
      this.displayedColumns = ['checkbox', 'linkDetail', 'mostRelevantName', 'nlpJson.sentiment.score', 'actions', 'matched'];
    } else {
      this.displayedColumns = ['checkbox', 'linkDetail', 'matched'];
    }
  }

  /**
   * Open NLP details popup window
   * @method selectDetail
   */
  selectDetail(item: any): void {
    this.dialogRefInternetSearch = this.dialog.open(InternetSearchDetailComponent, {
      data: item.nlpJson,
      autoFocus: false,
      width: '1300px',
      panelClass: 'internect-search-detail-dialog'
    });
  }
}
